import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "mb-4",
  style: {"background-color":"var(--color-white)"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  class: "mb-3",
  style: {"min-height":"64px","background-color":"var(--color-light-light-gray)","display":"flex","align-items":"flex-start","padding":"20px"}
}
const _hoisted_5 = { style: {"white-space":"nowrap","flex-shrink":"0","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","font-size":"20px"} }
const _hoisted_6 = { style: {"flex":"1","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","padding-left":"20px","color":"var(--description-color)","font-size":"16px"} }
const _hoisted_7 = { style: {"white-space":"nowrap","flex-shrink":"0","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","font-size":"20px"} }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = {
  class: "mb-3",
  style: {"background-color":"var(--color-light-light-gray)","padding":"20px"}
}
const _hoisted_10 = { style: {"display":"flex","align-items":"flex-start","min-height":"20px"} }
const _hoisted_11 = { style: {"white-space":"nowrap","flex-shrink":"0","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","font-size":"20px"} }
const _hoisted_12 = { style: {"flex":"1","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","padding-left":"20px","color":"var(--description-color)","font-size":"16px"} }
const _hoisted_13 = { style: {"font-size":"12px","margin":"0","margin-top":"2px","color":"var(--description-color)"} }
const _hoisted_14 = {
  key: 1,
  style: {"display":"flex","align-items":"flex-start","min-height":"32px"}
}
const _hoisted_15 = { style: {"white-space":"nowrap","flex-shrink":"0","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","font-size":"20px"} }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = {
  class: "mb-3",
  style: {"min-height":"64px","background-color":"var(--color-light-light-gray)","display":"flex","align-items":"flex-start","padding":"20px"}
}
const _hoisted_18 = { style: {"white-space":"nowrap","flex-shrink":"0","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","font-size":"20px"} }
const _hoisted_19 = { style: {"flex":"1","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","padding-left":"20px","color":"var(--description-color)","font-size":"16px"} }
const _hoisted_20 = { style: {"white-space":"nowrap","flex-shrink":"0","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","font-size":"20px"} }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = {
  class: "mb-3",
  style: {"min-height":"64px","background-color":"var(--color-light-light-gray)","display":"flex","align-items":"flex-start","padding":"20px"}
}
const _hoisted_23 = { style: {"white-space":"nowrap","flex-shrink":"0","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","font-size":"20px"} }
const _hoisted_24 = { style: {"flex":"1","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","padding-left":"20px","color":"var(--description-color)","font-size":"16px"} }
const _hoisted_25 = { style: {"white-space":"nowrap","flex-shrink":"0","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","font-size":"20px"} }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = {
  class: "mb-3",
  style: {"min-height":"64px","background-color":"var(--color-light-light-gray)","display":"flex","align-items":"flex-start","padding":"20px"}
}
const _hoisted_28 = { style: {"white-space":"nowrap","flex-shrink":"0","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","font-size":"20px"} }
const _hoisted_29 = { style: {"flex":"1","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","padding-left":"20px","color":"var(--description-color)","font-size":"16px"} }
const _hoisted_30 = { style: {"white-space":"nowrap","flex-shrink":"0","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","font-size":"20px"} }
const _hoisted_31 = {
  key: 0,
  class: "col-12"
}
const _hoisted_32 = {
  class: "mb-3",
  style: {"background-color":"var(--color-light-light-gray)","padding":"20px"}
}
const _hoisted_33 = { style: {"display":"flex","align-items":"flex-start","min-height":"20px"} }
const _hoisted_34 = { style: {"white-space":"nowrap","flex-shrink":"0","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","font-size":"20px"} }
const _hoisted_35 = { style: {"flex":"1","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","padding-left":"20px","color":"var(--description-color)","font-size":"16px"} }
const _hoisted_36 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.selectedPanels.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.solarPanels.title")), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { style: {"display":"inline-block","width":"20px"} }, null, -1)),
                  _cache[1] || (_cache[1] = _createTextVNode("|"))
                ]),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.panelsString), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.solarPanels.title")), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { style: {"display":"inline-block","width":"20px"} }, null, -1)),
                  _cache[3] || (_cache[3] = _createTextVNode("|"))
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("span", { style: {"padding-left":"20px","flex":"1","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","color":"var(--description-color)","font-size":"16px"} }, "N/A", -1))
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.selectedInverters.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.inverters.title")), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"display":"inline-block","width":"20px"} }, null, -1)),
                    _cache[6] || (_cache[6] = _createTextVNode("|"))
                  ]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.invertersString), 1)
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("project.previewAndReport.inverters.note")), 1)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.inverters.title")), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { style: {"display":"inline-block","width":"20px"} }, null, -1)),
                  _cache[8] || (_cache[8] = _createTextVNode("|"))
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("span", { style: {"padding-left":"20px","flex":"1","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","color":"var(--description-color)","font-size":"16px"} }, "N/A", -1))
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_ctx.selectedBatteries.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_18, [
                  _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.batteries.title")), 1),
                  _cache[10] || (_cache[10] = _createElementVNode("span", { style: {"display":"inline-block","width":"20px"} }, null, -1)),
                  _cache[11] || (_cache[11] = _createTextVNode("|"))
                ]),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.batteriesString), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.batteries.title")), 1),
                  _cache[12] || (_cache[12] = _createElementVNode("span", { style: {"display":"inline-block","width":"20px"} }, null, -1)),
                  _cache[13] || (_cache[13] = _createTextVNode("|"))
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("span", { style: {"padding-left":"20px","flex":"1","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","color":"var(--description-color)","font-size":"16px"} }, "N/A", -1))
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          (_ctx.selectedEVChargers.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.evChargers.title")), 1),
                  _cache[15] || (_cache[15] = _createElementVNode("span", { style: {"display":"inline-block","width":"20px"} }, null, -1)),
                  _cache[16] || (_cache[16] = _createTextVNode("|"))
                ]),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.evChargersString), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", _hoisted_25, [
                  _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.evChargers.title")), 1),
                  _cache[17] || (_cache[17] = _createElementVNode("span", { style: {"display":"inline-block","width":"20px"} }, null, -1)),
                  _cache[18] || (_cache[18] = _createTextVNode("|"))
                ]),
                _cache[19] || (_cache[19] = _createElementVNode("span", { style: {"padding-left":"20px","flex":"1","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","color":"var(--description-color)","font-size":"16px"} }, "N/A", -1))
              ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          (_ctx.selectedMeters.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_28, [
                  _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.meters.title")), 1),
                  _cache[20] || (_cache[20] = _createElementVNode("span", { style: {"display":"inline-block","width":"20px"} }, null, -1)),
                  _cache[21] || (_cache[21] = _createTextVNode("|"))
                ]),
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.metersString), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", _hoisted_30, [
                  _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.meters.title")), 1),
                  _cache[22] || (_cache[22] = _createElementVNode("span", { style: {"display":"inline-block","width":"20px"} }, null, -1)),
                  _cache[23] || (_cache[23] = _createTextVNode("|"))
                ]),
                _cache[24] || (_cache[24] = _createElementVNode("span", { style: {"padding-left":"20px","flex":"1","line-height":"1.2","margin-top":"calc((1.2 * 12px - 1.2em) / 2)","color":"var(--description-color)","font-size":"16px"} }, "N/A", -1))
              ], 64))
        ])
      ]),
      (_ctx.shouldShowConnections)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("span", _hoisted_34, [
                  _createTextVNode(_toDisplayString(_ctx.$t("project.previewAndReport.connections.title")), 1),
                  _cache[25] || (_cache[25] = _createElementVNode("span", { style: {"display":"inline-block","width":"20px"} }, null, -1)),
                  _cache[26] || (_cache[26] = _createTextVNode("|"))
                ]),
                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("project.previewAndReport.connections.description")), 1)
              ]),
              (_ctx.shouldShowDisclaimer)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: {"font-size":"12px","margin":"0","margin-top":"2px","color":"var(--description-color)"},
                    innerHTML: _ctx.$t('project.previewAndReport.connections.disclaimer')
                  }, null, 8, _hoisted_36))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}